<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 8 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">

        <a-form-model-item
            prop="description"
          label="评价描述">
          <a-textarea :rows="4" placeholder="请输入评价描述" v-model="model.description" />
        </a-form-model-item>
        <a-form-model-item
            prop="minAvg"
          label="个人值大于平均值的最小个数">
          <a-input-number v-model="model.minAvg" :min="0" :precision="0" style="width: 100%" placeholder="请输入个人值大于平均值的最小个数" />
        </a-form-model-item>
        <a-form-model-item
            prop="maxAvg"
          label="个人值大于平均值的最大个数">
          <a-input-number v-model="model.maxAvg" :min="0" :precision="0" style="width: 100%" placeholder="请输入个人值大于平均值的最大个数" />
        </a-form-model-item>
        <a-form-model-item
          label="周期">
          <a-select v-model="model.periodItemId" placeholder="请选择">
            <a-select-option :value="item.id" v-for="item in periodItemList" :key="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  export default {
    name: "ProjectResultConfig2Modal",
    components: { ATextarea },
    data () {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        title:"操作",
        visible: false,
        model: {},
        rules:{
          description:[baseRules.required],
          minAvg:[baseRules.required],
          maxAvg:[baseRules.required],
        },
        confirmLoading: false,

        url: {
          add: "/project/projectResultConfig2/add",
          edit: "/project/projectResultConfig2/edit",
        },
        periodItemList:[],
      }
    },
    created () {
      getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0'}).then(res=>{
        if(res.success){
          this.periodItemList=res.result
        }
      })
    },
    methods: {
      add () {
        this.edit({
          projectId:this.projectId
        });
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>